export default __webpack_public_path__ + "static/media/banco-coopcentral.9fc40fb9.svg";